import styled from 'styled-components';

interface IContainerProps {
    bordered?: boolean;
    borderBottom?: string;
}

export const Container = styled.div<IContainerProps>`

    width: 100%;

    & tr {
        background-color: #fafafa;
    }

    & th {
        color: #74777a;
        vertical-align: middle;
        padding: 6px;
    }

    & td {
        background-color: #fff;
        color: #74777a;
        padding: 6px;
        vertical-align: middle;
    }

    & .table {
        margin-bottom: 0px;
        border: ${props => props.bordered ? '1px solid #dee2e6' : '#dee2e6'};
        border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #dee2e6'};
    }

    & .table > :not(:first-child) {
        border-top: 0px;
    }

    & .table > :not(caption) > * > * {
      border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #dee2e6'};
    }
`